class CarouselArrows extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.prevBtn = this.querySelector('[data-carousel-prev]');
    this.nextBtn = this.querySelector('[data-carousel-next]');

    if (!this.track) return;

    this.handlePrev = () => this.scrollByCard(-1);
    this.handleNext = () => this.scrollByCard(1);

    this.prevBtn?.addEventListener('click', this.handlePrev);
    this.nextBtn?.addEventListener('click', this.handleNext);
  }

  disconnectedCallback() {
    this.prevBtn?.removeEventListener('click', this.handlePrev);
    this.nextBtn?.removeEventListener('click', this.handleNext);
  }

  scrollByCard(direction) {
    const card = this.track.querySelector(':scope > *');
    if (!card) return;

    const trackStyle = getComputedStyle(this.track);
    const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0') || 0;
    const distance = (card.getBoundingClientRect().width + gap) * direction;

    this.track.scrollBy({ left: distance, behavior: 'smooth' });
  }
}

if (!customElements.get('carousel-arrows')) {
  customElements.define('carousel-arrows', CarouselArrows);
}
